'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: ['user', 'buffer'],
    computed: {
        status: function status() {
            if (!this.user || !this.buffer) {
                return '';
            }

            return this.user.typingStatus(this.buffer.name).status;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/TypingStatusIndicator.vue
// module id = /8BR
// module chunks = 1